import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogdelaccountComponent } from '../dialogdelaccount/dialogdelaccount.component';

@Injectable({
  providedIn: 'root'
})
export class DialogaccountdeleteService {

  constructor(private dialog:MatDialog) { }

  openDialog(){
   return this.dialog.open(DialogdelaccountComponent,{
     width:'40%',
   });
  }
}
